export default __webpack_public_path__ + "static/media/atom.ca052752.svg";